import DateFormatter from 'features/shared/components/formatters/DateFormatter';
import PriceFormatter from 'features/shared/components/formatters/PriceFormatter';
import React from 'react';
import AdvanceDTO from '../dtos/AdvanceDTO';
import ContractLink from './ContractLink';
import styles from './advance.module.scss';
import { useTranslation } from 'react-i18next';
interface Props {
  advance: AdvanceDTO;
}

const Advance = ({ advance }: Props) => {
  //translations
  const tLabels = useTranslation(["invoice\\invoice"]).t;

  return (
    <div className="row no-gutters">
      <div className="col col-sm-6">
        <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
          <span className="mr-2">{tLabels("advance.advanceFor")}</span>
          <ContractLink entityLink={advance.entityLink!} />
        </div>
      </div>
      <div className="col-auto col-sm-6 pl-3">
        <div className="row flex-column flex-sm-row no-gutters">
          <div className="col-sm-6 order-1 order-sm-0 text-right text-sm-left">
            <span className={styles.date}>
              <DateFormatter date={advance.dueDate!} />
            </span>
          </div>
          <div className="col-sm-6 text-right">
            <PriceFormatter amount={advance.amount!} currency={advance.currency!} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Advance;
